export enum Color {
  // Default
  Black = '#000',
  White = '#FFFF',
  Transparent = 'transparent',
  // Gray
  Gray500 = '#6C6C6C',
  Gray400 = '#A1A1A1',
  Gray300 = '#E2E2E2',
  Gray200 = '#EEF0ED',
  Gray100 = '#F7F8F6',
  // Error
  Error100 = '#FCEEEA',
  Error300 = '#F5CCC0',
  Error500 = '#DE542C',
  // Warning
  Warning100 = '#FFF7D9',
  Warning300 = '#FBE2B0',
  Warning500 = '#DB9919',
  // Success
  Success100 = '#E9F8E9',
  Success200 = '#CCEDCC',
  Success500 = '#00A300',
  // Blue
  Blue100 = '#ECF0FF',
  Blue500 = '#002DD2',
  // Other
  Background = '#EEF0ED',
  Stroke = '#E2E2E2',
  Orange = '#DE542C',
  // Fluorescent
  Cyan = '#01FFFF',
  Blue = '#0000FF',
  Green = '#00FF00',
  Magenta = '#FF00FF',
}
